import reactHtml5Video from "./react-html5video";
import reactDatePicker from "./react-datepicker";
import reactCollapse from "./react-collapse";

export default `
  ${reactHtml5Video}
  ${reactDatePicker}
  ${reactCollapse}
`;
